export default "__VITE_ASSET__lyhFoxWK__"